import React from 'react'
import { useReportes } from '../hooks/useReportes'

const Reportes = () => {

    const { cantidad, sumar, mostrarAlerta } = useReportes()
    
    return (
        <div>

            <button onClick={ sumar }>sumar 1</button>
            <h1>
                { cantidad }
            </h1>

            { mostrarAlerta && (
                <h1>ya son más de 10</h1>
            )}

            

        </div>
    )
}

export default Reportes
